<template>
    <component :is="template">
        <v-container>
            <div class="contents-area">
                <div class="contents-area__inner">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">도서 &amp; 상품검색 결과</h2>
                    </div>
                    <product-list searchKey="name" :searchValue="$route.query.searchValue" :routable="false" />
                </div>
            </div>

            <!-- <div class="contents-area mt-20px mt-md-30px">
                <div class="contents-area__inner">
                    <div class="tit-wrap tit-wrap--unberline">
                        <h2 class="tit">상품권 검색결과</h2>
                    </div>
                    <p v-if="!this.logon" class="font-size-14 font-size-md-16">상품권 검색은 로그인후 이용할 수 있습니다</p>
                    <giftcard-list v-if="this.logon" searchKey="name" :searchValue="$route.query.searchValue" />
                </div>
            </div> -->
        </v-container>
    </component>
</template>
<script>
import ProductList from "@/components/client/shop/product/product-list.vue";
import GiftcardList from "@/components/client/gshop/giftcard/giftcard-list.vue";
export default {
    components: {
        ProductList,
        GiftcardList
    },
    computed: {
        template(){
            return () => import(`@/templates/${this.$theme.pages.default}`);
        },
        accessToken(){ return this.$store.state.accessToken; },
        logon(){ return !!this.accessToken },
    }
}
</script>